import { jsx as _jsx } from "react/jsx-runtime";
import FinancialTableRow from '../../../molecules/table/FinancialTableRow';
import styled, { css } from 'styled-components';
import Flex from '../../../atoms/Flex';
import { readableNumberParts } from '../../../../helpers/Numbers';
import { getAppThemeName } from '../../../../services/appTheme';
const DossierTotalTableRow = styled(FinancialTableRow) `
    border: 1px solid #ececec;
    border-radius: 6px;
    margin-bottom: 25px;

    .table-cell__label {
        color: ${props => props.theme.primary.base};
        font-weight: 700;
        font-size: 18px;
    }

    .table-cell__value {
        color: ${props => props.appTheme === 'invoned'
    ? props.theme.primary.base
    : props.theme.secondary};
        font-weight: 700;
        font-size: 18px;
    }

    ${props => props.highlighted &&
    css `
            margin-top: 15px;

            &:nth-child(odd) {
                background-color: ${props.theme.secondary};
            }

            .table-cell__label,
            .table-cell__value {
                color: white;
            }

            @media only screen and (min-width: 992px) {
                &:nth-child(odd) {
                    background-color: ${props.theme.secondary};
                }
            }
        `}
`;
const DossierTotal = ({ label, amount, highlighted = false, }) => {
    return (_jsx(Flex, { column: true, children: _jsx(DossierTotalTableRow, { noHover: true, label: label, highlighted: highlighted, amount: readableNumberParts(amount, 'EUR').longDecimal, appTheme: getAppThemeName() }) }));
};
export default DossierTotal;
